import { apiClient } from "./ApiClient";
import ApiUrlConstants from "../constants/ApiUrlConstants";
import { handleResponse, handleError } from "./GenericResponseHandler";

class API {
  getUserStats(userId) {
    let url = ApiUrlConstants.GET_PROFILE_STATS;
    url += `/${userId}`;
    return apiClient.get(url).then(handleResponse).catch(handleError);
  }
  getBlockHistory(userId) {
    let url = ApiUrlConstants.BLOCK_HISTORY;
    url += `/${userId}`;
    return apiClient.get(url).then(handleResponse).catch(handleError);
  }

  searchUsers(queryString) {
    let url = ApiUrlConstants.SEARCH_USERS;
    if (!!queryString) {
      url += `?${queryString}`;
    }
    return apiClient.get(url).then(handleResponse).catch(handleError);
  }

  deleteUserAccount(userId, deletedReason = null) {
    let url = ApiUrlConstants.DELETE_ACCOUNT;
    url = url.replace(/{user_id}/g, userId);
    return apiClient
      .post(url, { userId, deletedReason })
      .then(handleResponse)
      .catch(handleError);
  }

  releasePhoneNumber(userId, reason) {
    const url = ApiUrlConstants.RELEASE_PHONE_NUMBER.replace(/{userId}/g, userId);
    return apiClient
      .post(url, { reason })
      .then(handleResponse)
      .catch(handleError);
  }

  blockUser(userId, blockReason) {
    let url = ApiUrlConstants.USER_BLOCK;
    let payload = {
      userId,
      reason: blockReason,
    };
    return apiClient
      .post(url, payload)
      .then(handleResponse)
      .catch(handleError);
  }

  unBlockUser(userId, unBlockReason) {
    let url = ApiUrlConstants.USER_UNBLOCK;
    let payload = {
      userId,
      reason: unBlockReason,
    };
    return apiClient
      .post(url, payload)
      .then(handleResponse)
      .catch(handleError);
  }
  runRegistration(userId) {
    let url = ApiUrlConstants.RUN_REGISTRATION;
    let payload = {
      userId
    };
    return apiClient
      .post(url, payload)
      .then(handleResponse)
      .catch(handleError);
  }

  extraPlaidAttempt(userId) {
    let url = ApiUrlConstants.EXTRA_PLAID_ATTEMPT;
    let payload = {
      userId
    };
    return apiClient
      .post(url, payload)
      .then(handleResponse)
      .catch(handleError);
  }

  closeSaveAndBuild(userId, loanId) {
    let url = ApiUrlConstants.CLOSE_SAVE_BUILDER;
    let payload = {
      userId,
      loanId,
    };
    return apiClient
      .post(url, payload)
      .then(handleResponse)
      .catch(handleError);
  }

  cancelSubscription(userId, subscriptionId, cancelImmediately = true, cancellationReason = null) {
    let url = ApiUrlConstants.CANCEL_SUBSCRIPTION;
    let payload = {
      userId,
      subscriptionId,
      cancelImmediately,
      cancellationReason
    };
    return apiClient
      .post(url, payload)
      .then(handleResponse)
      .catch(handleError);
  }

  resumeSubscription(userId, subscriptionId) {
    let url = ApiUrlConstants.RESUME_SUBSCRIPTION;
    let payload = {
      userId,
      subscriptionId
    };
    return apiClient
      .post(url, payload)
      .then(handleResponse)
      .catch(handleError);
  }

  getUserNotes({ userId }) {
    const url = ApiUrlConstants.GET_USER_NOTES.replace(/{userId}/g, userId);
    
    return apiClient
      .get(url)
      .then(handleResponse)
      .catch(handleError);
  }

  postUserNote({ userId, message }) {
    const url = ApiUrlConstants.POST_USER_NOTES.replace(/{userId}/g, userId);
    const payload = {
      userId,
      message
    };

    return apiClient
      .post(url, payload)
      .then(handleResponse)
      .catch(handleError);
  }

  cancelCreditCard(userId, ccId, closeAccounts) {
    let url = ApiUrlConstants.CANCEL_CREDIT_CARD;
    let payload = {
      userId,
      closeAssociatedCreditAccount: closeAccounts,
    };
    return apiClient
      .post(url, payload)
      .then(handleResponse)
      .catch(handleError);
  }
  
  createNewCreditCard({ userId }) {
    let url = ApiUrlConstants.CREATE_NEW_CREDIT_CARD;
    let payload = {
      userId,
      cardType: 'basicCreditCard',
    };
    return apiClient
      .post(url, payload)
      .then(handleResponse)
      .catch(handleError);
  }

  disableAutoPay(userId) {
    let url = ApiUrlConstants.DISABLE_AUTOPAY;
    let payload = {
      userId,
    };
    return apiClient
      .post(url, payload)
      .then(handleResponse)
      .catch(handleError);
  }


  enableBackupPayment(userId) {
    let url = ApiUrlConstants.ENABLE_BACKUP_PAYMENT;
    let payload = {
      userId,
    };
    return apiClient
      .post(url, payload)
      .then(handleResponse)
      .catch(handleError);
  }

  forceAutoPay(userId) {
    let url = ApiUrlConstants.FORCE_AUTOPAY;
    let payload = {
      userId,
    };
    return apiClient
      .post(url, payload)
      .then(handleResponse)
      .catch(handleError);
  }
  /**
   * Get the list of the mechants
   * @returns
   */
  getMerchants() {
    let url = ApiUrlConstants.GET_MERCHANTS;
    return apiClient.get(url).then(handleResponse).catch(handleError);
  }

  updateUserAccount(data, isRegistered) {
    let url = ApiUrlConstants.UPDATE_USER_INFO;
    return apiClient.post(url, data).then(handleResponse).catch(handleError);
  }

  changeActivePlaidAccount = (userId, productId) => {
    let url = ApiUrlConstants.CHANGE_ACTIVE_PLAID;
    return apiClient
      .post(url, { id: productId, userId })
      .then(handleResponse)
      .catch(handleError);
  };

  plaidBalances = (userId) => {
    let url = ApiUrlConstants.PLAID_BALANCES;
    url += `/${userId}`;

    return apiClient.get(url).then(handleResponse).catch(handleError);
  };

  getPlaidEvents = (userId, before) => {
    let url = ApiUrlConstants.GET_PLAID_EVENTS;
    url = url.replace(/{user_id}/g, userId);
    const params = before ? { before } : undefined;
    return apiClient.get(url, { params }).then(handleResponse).catch(handleError);
  };

  changeDueDate = (userId, dueDay, isSavingBuilder = false, id) => {
    let url = ApiUrlConstants.CHANGE_DUE_DAY_CC;

    if (isSavingBuilder) {
      url = ApiUrlConstants.CHANGE_DUE_DAY_SB;
      return apiClient
        .post(url, { dueDay, userId, loanId: id })
        .then(handleResponse)
        .catch(handleError);
    } else {
      return apiClient
        .post(url, { dueDay, userId, creditCardAccountId: id })
        .then(handleResponse)
        .catch(handleError);
    }
  };


  chargeFroSilaStripe = (userId, productId, paymentProductType, plaidId = null) => {
    let url = ApiUrlConstants.CHARGE_BACKUP_SILA_PAYMENT;
    const payload = { userId, productId, paymentProductType };
    
    if (plaidId)
      payload.plaidId = plaidId;
    
    return apiClient
      .post(url, payload)
      .then(handleResponse)
      .catch(handleError);
  };


  addSpendPower = (userId, spendPowerInCents) => {
    let url = ApiUrlConstants.ADD_SPEND_POWER;
    return apiClient
      .post(url, { userId, spendPowerInCents })
      .then(handleResponse)
      .catch(handleError);
  };


  getDocumentTypes = () => {
    let url = ApiUrlConstants.GET_DOCUMENT_TYPES;
    return apiClient.get(url).then(handleResponse).catch(handleError);
  };

  uploadDocument = (userId, documentType, description, file) => {
    let url = ApiUrlConstants.UPLOAD_DOCUMENT;
    
    if (!file) {
      return Promise.reject(new Error('No file selected'));
    }
    
    const formData = new FormData();
    formData.append('file', file);
    formData.append('userId', userId);
    formData.append('documentType', documentType);
    formData.append('description', description);
        
    return apiClient.uploadImage(url, formData).then(handleResponse).catch(handleError);
  };

  getDocuments = (userId) => {
    let url = ApiUrlConstants.GET_DOCUMENTS;
    url = url.replace(/user_id/g, userId);
    return apiClient.get(url).then(handleResponse).catch(handleError);
  };

  forcefullyPullDocument = (userId) => {
    let url = ApiUrlConstants.FORCE_PULL_REPORT;
    return apiClient.post(url, { userId }).then(handleResponse).catch(handleError);
  };

  reenrollExperianUser = (userId) => {
    const url = ApiUrlConstants.EXPERIAN_REENROLL;
    return apiClient.post(url, { userId }).then(handleResponse).catch(handleError);
  };

  refundUser(userId, refundAmountToUser, referenceId, refundFromUserWallet, productType, zendeskTicketNum, chargeId, refundReason, plaidAccountId, refundAmountToCCAccount, transactionId) {
    let url = ApiUrlConstants.REFUND_USER;
    return apiClient.post(url, {
      userId, refundAmountToUser, referenceId,
      refundFromUserWallet, productType,
      zendeskTicketNum, chargeId, refundReason,
      plaidAccountId, refundAmountToCCAccount, transactionId
    }).then(handleResponse).catch(handleError);
  }

  cancelRefund(userId, transactionId) {
    const url = ApiUrlConstants.CANCEL_REFUND;
    return apiClient.post(url, {userId, transactionId}).then(handleResponse).catch(handleError);
  }

  toggleAutoRenewSB(userId, willAutoRenew) {
    const url = ApiUrlConstants.TOGGLE_AUTO_RENEW_SB;
    return apiClient.post(url, {userId, willAutoRenew}).then(handleResponse).catch(handleError)
  }

  whitelistUserSSN(userId) {
    const url = ApiUrlConstants.WHITELIST_USER_SSN;
    return apiClient.post(url, {userId}).then(handleResponse).catch(handleError);
  }
  
  undoWhitelistUserSSN(userId) {
    const url = ApiUrlConstants.UNDO_WHITELIST_USER_SSN.replace(/{userId}/g, userId);
    return apiClient.delete(url).then(handleResponse).catch(handleError);
  }

  previewInvoice(userId, subscriptionId) {
    const url = ApiUrlConstants.PREVIEW_INVOICE;
    return apiClient.post(url, {userId, subscriptionId}).then(handleResponse).catch(handleError);
  }

  getStripeUserCharges({ userId }) {
    const url = ApiUrlConstants.GET_USER_STRIPE_CHARGES.replace(/{userId}/g, userId);
    return apiClient.get(url).then(handleResponse).catch(handleError);
  }

  getStripeUserDisputes({ userId, chargeId }) {
    const url = ApiUrlConstants
      .GET_USER_STRIPE_DISPUTES
      .replace(/{userId}/g, userId)
      .replace(/{chargeId}/g, chargeId);
    return apiClient.get(url).then(handleResponse).catch(handleError);
  }

  getStripeUserInvoices({ userId }) {
    const url = ApiUrlConstants
      .GET_USER_STRIPE_INVOICES
      .replace(/{userId}/g, userId);
    return apiClient.get(url).then(handleResponse).catch(handleError);
  }

  getStripeCustomer({ userId }) {
    const url = ApiUrlConstants.GET_USER_STRIPE_CUSTOMER.replace(/{userId}/g, userId);
    return apiClient.get(url).then(handleResponse).catch(handleError);
  }

  getSubscriptionOffersPreview({ userId, type, planId, cardId }) {
    const url = ApiUrlConstants.GET_USER_SUBSCRIPTION_OFFERS_PREVIEW.replace(/{userId}/g, userId);
    return apiClient.post(url, { offerContext: type, planId, cardId }).then(handleResponse).catch(handleError);
  }

  getSubscriptionOffersAccept({ userId, type, planId, cardId = null }) {
    const url = ApiUrlConstants.GET_USER_SUBSCRIPTION_OFFERS_ACCEPT.replace(/{userId}/g, userId);
    return apiClient.post(url,{ offerContext: type, planId, cardId }).then(handleResponse).catch(handleError);
  }

  getPlaidAccountDetails(userId) {
    let url = ApiUrlConstants.GET_PLAID_ACCOUNT_DETAILS
    url += `/${userId}`;

    return apiClient.get(url).then(handleResponse).catch(handleError);
  }

  plaidOwnerName(plaidId, userId) {
    let url = ApiUrlConstants.PLAID_OWNER_NAME;
    let payload = {
      plaidId,
      userId
    };
    return apiClient
      .post(url, payload)
      .then(handleResponse)
      .catch(handleError);
  }

  updateSubscription(userId, subscriptionPlanId) {
    let url = ApiUrlConstants.UPDATE_SUBSCRIPTION;
    return apiClient.post(url, {userId, subscriptionPlanId}).then(handleResponse).catch(handleError);
  }

  previewInvoiceUpdatedSubscription(userId, subscriptionId, updatedSubscriptionPlanId) {
    let url = ApiUrlConstants.PREVIEW_INVOICE;
    return apiClient.post(url, {userId, subscriptionId, updatedSubscriptionPlanId})
        .then(handleResponse).catch(handleError);
  }

  getSubscriptionPlans() {
    let url = ApiUrlConstants.GET_SUBSCRIPTION_PLANS;
    return apiClient.get(url).then(handleResponse).catch(handleError)
  }

  getFirebaseDeviceEvents(userId) {
    let url = ApiUrlConstants.FIREBASE_DEVICE_EVENTS;
    url += `/${userId}`;

    return apiClient.get(url).then(handleResponse).catch(handleError);
  }

  getAdverseActionNotices(userId) {
    const url = ApiUrlConstants.GET_ADVERSE_ACTIONS.replace(/{userId}/, userId);
    return apiClient.get(url).then(handleResponse).catch(handleError);
  }

  getDocumentVerifications(userId) {
    const url = ApiUrlConstants.GET_DOCUMENT_VERIFICATIONS.replace(/{userId}/, userId);
    return apiClient.get(url).then(handleResponse).catch(handleError);
  }

  createDocumentVerificationLink(userId, requestEmail, zendeskTicket) {
    const url = ApiUrlConstants.GET_DOCUMENT_VERIFICATION_LINK;
    const payload = { userId, requestEmail, zendeskTicket };
    return apiClient.post(url, payload).then(handleResponse).catch(handleError);
  }

  patchBloomStatement(bloomStatementId, {
    statementDate,
    reportingCycle,
    accountId,
    currentBalance,
    daysDelinquent,
    scheduledMonthlyPayment,
    actualMonthlyPayment,
    creditLimit,
    amountPastDue,
    lastPaymentDate,
  }) {
    let url = ApiUrlConstants.PATCH_BLOOM_STATEMENT;
    url = url.replace(/{bloomStatementId}/g, bloomStatementId);
    
    return apiClient.patch(url, {
      statementDate,
      reportingCycle,
      accountId,
      currentBalance,
      daysDelinquent,
      scheduledMonthlyPayment,
      actualMonthlyPayment,
      creditLimit,
      amountPastDue,
      lastPaymentDate,
    }).then(handleResponse).catch(handleError);
  }

  postCreateStatement({
    avaUserId,
    reportingCycle,
    productId,
    isClosed,
    statementId,
    statementTs,
    bloomAccountId,
    shouldPersist
  }) {
    const { POST_CREATE_STATEMENT } = ApiUrlConstants;
    
    return apiClient.post(POST_CREATE_STATEMENT, {
      avaUserId,
      reportingCycle,
      productId,
      isClosed,
      statementId,
      statementTs,
      bloomAccountId
    }, { params: { shouldPersist }}).then(handleResponse).catch(handleError);
  }

  deleteRevolvingFurnishingAccount({
    accountId,
    isFraudRelated,
    zendeskTicketNum,
    deleteNote,
    transactionsToVoid = null
  }) {
    let url = ApiUrlConstants.DELETE_REVOLVING_FURNISHING_ACCOUNT;

    return apiClient.post(url, {
      accountId,
      isFraudRelated: isFraudRelated ? true : false,
      zendeskTicketNum,
      deleteNote,
      transactionsToVoid
    }).then(handleResponse).catch(handleError);
  }
  
  deleteInstallmentFurnishingAccount({
    accountId,
    isFraudRelated,
    zendeskTicketNum,
    deleteNote
  }) {
    let url = ApiUrlConstants.DELETE_INSTALLMENT_FURNISHING_ACCOUNT;

    return apiClient.post(url, {
      accountId,
      isFraudRelated: isFraudRelated ? true : false,
      zendeskTicketNum,
      deleteNote
    }).then(handleResponse).catch(handleError);
  }
  
  postAddTrialSubscription({
    userId,
    subscriptionId,
    trialDays
  }) {
    const {
      ADD_TRIAL_SUBSCRIPTION
    } = ApiUrlConstants;

    return apiClient.post(ADD_TRIAL_SUBSCRIPTION, {
      userId,
      subscriptionId,
      trialDays
    }).then(handleResponse).catch(handleError);
  }

  getFirebaseLoginInfo({
    userId
  }) {
    const {
      FIREBASE_ACCOUNT_INFO
    } = ApiUrlConstants;

    const url = FIREBASE_ACCOUNT_INFO.replace(/{userId}/g, userId);

    return apiClient.get(url).then(handleResponse).catch(handleError);
  }

  getReferralLink({
    userId
  }) {
    const {
      GET_REFERRAL_LINK
    } = ApiUrlConstants;

    return apiClient.get(GET_REFERRAL_LINK, {
      params: {
        userId
      }
    }).then(handleResponse).catch(handleError);
  }

  deleteStripeCard({
    userId,
    cardId
  }) {
    const {
      DELETE_STRIPE_CARD
    } = ApiUrlConstants;

    const url = DELETE_STRIPE_CARD
      .replace(/{userId}/g, userId)
      .replace(/{cardId}/g, cardId);

    return apiClient.delete(url).then(handleResponse).catch(handleError);
  }

  postCreatePaymentLink({
    userId,
    ccAccountId,
    amountInCents,
    product
  }) {
    const {
      POST_CREATE_PAYMENT_LINK
    } = ApiUrlConstants;

    return apiClient.post(POST_CREATE_PAYMENT_LINK, {
      userId,
      ccAccountId,
      amountInCents,
      product
    }).then(handleResponse).catch(handleError);
  }
  
  getPaymentLinkList({
    userId
  }) {
    const {
      GET_PAYMENT_LINKS_LIST
    } = ApiUrlConstants;

    return apiClient.get(GET_PAYMENT_LINKS_LIST, {
      params: { userId }
    }).then(handleResponse).catch(handleError);
  }
  
  getUserBlockedStatus({
    userId
  }) {
    const {
      GET_USER_STATUS
    } = ApiUrlConstants;

    const url = GET_USER_STATUS
      .replace(/{userId}/g, userId)

    return apiClient.get(url).then(handleResponse).catch(handleError);
  }
  
  getFurnishingDetails({
    userId
  }) {
    const {
      GET_FURNISHING_DETAILS
    } = ApiUrlConstants;

    const url = GET_FURNISHING_DETAILS
      .replace(/{userId}/g, userId)

    return apiClient.get(url).then(handleResponse).catch(handleError);
  }
  
  getFurnishingEvents({
    userId
  }) {
    const {
      USER_FURNISHING_EVENTS
    } = ApiUrlConstants;

    const url = USER_FURNISHING_EVENTS
      .replace(/{userId}/g, userId)

    return apiClient.get(url).then(handleResponse).catch(handleError);
  }

  getSubscriptionsDetails({
    userId
  }) {
    const {
      GET_SUBSCRIPTION_DETAILS
    } = ApiUrlConstants;

    const url = GET_SUBSCRIPTION_DETAILS
      .replace(/{userId}/g, userId)

    return apiClient.get(url).then(handleResponse).catch(handleError);
  }
  
  getFurnishingChanges({
    userId
  }) {
    const {
      GET_FURNISHING_CHANGES
    } = ApiUrlConstants;

    const url = GET_FURNISHING_CHANGES
      .replace(/{userId}/g, userId)

    return apiClient.get(url).then(handleResponse).catch(handleError);
  }

  getUserSummary({
    userId
  }) {
    const {
      GET_USER_SUMMARY
    } = ApiUrlConstants;

    const url = GET_USER_SUMMARY
      .replace(/{userId}/g, userId)

    return apiClient.get(url).then(handleResponse).catch(handleError);
  }
  
  getFurnishingErrors({
    userId
  }) {
    const {
      GET_FURNISHING_ERRORS
    } = ApiUrlConstants;

    const url = GET_FURNISHING_ERRORS
      .replace(/{userId}/g, userId)

    return apiClient.get(url).then(handleResponse).catch(handleError);
  }
  
  patchBloomAccount({
    accountId,
    status,
    closureDate
  }) {
    const {
      PATCH_BLOOM_ACCOUNT
    } = ApiUrlConstants;

    const url = PATCH_BLOOM_ACCOUNT
      .replace(/{account_id}/g, accountId);

    return apiClient
      .patch(url, {
        status,
        closeDate: closureDate
      }).then(handleResponse).catch(handleError);
  }

  postAccountClose({
    productId,
    closingType,
    chargeOffAmount,
    userId
  }) {
    const {
      POST_ACCOUNT_CLOSING
    } = ApiUrlConstants;

    return apiClient
      .post(
        POST_ACCOUNT_CLOSING, {
          productId,
          closingType,
          chargeOffAmount,
          userId
        }).then(handleResponse).catch(handleError);
  }
  
  postReversalAccountClose({
    productId,
    closingType,
    userId
  }) {
    const {
      POST_ACCOUNT_CLOSING_REVERSAL
    } = ApiUrlConstants;

    return apiClient
      .post(
        POST_ACCOUNT_CLOSING_REVERSAL, {
          productId,
          closingType,
          userId
        }).then(handleResponse).catch(handleError);
  }
  
  postVoidTransactions({
    userId,
    transactionsToVoid,
    disputeReason
  }) {
    const {
      POST_VOID_TRANSACTIONS
    } = ApiUrlConstants;

    return apiClient
      .post(
        POST_VOID_TRANSACTIONS, {
          userId,
          transactionsToVoid,
          disputeReason
        }).then(handleResponse).catch(handleError);
  }

  getRentReporting({ userId }) {
    const {
      GET_RENT_REPORTING
    } = ApiUrlConstants;
    return apiClient.get(GET_RENT_REPORTING, { params: { userId } }).then(handleResponse).catch(handleError);
  }
  
  deletePlaidAccount({
    userId,
    plaidAccountId
  }) {
    const {
      DELETE_PLAID_ACCOUNT
    } = ApiUrlConstants;

    const url = DELETE_PLAID_ACCOUNT
      .replace(/{plaidAccountId}/g, plaidAccountId)
      .replace(/{userId}/g, userId);

    return apiClient.delete(url).then(handleResponse).catch(handleError);
  }

  hidePlaidAccount({
    userId,
    plaidAccountId
  }) {
    const {
      HIDE_PLAID_ACCOUNT
    } = ApiUrlConstants;

    return apiClient
      .post(HIDE_PLAID_ACCOUNT, { id: plaidAccountId, userId })
      .then(handleResponse)
      .catch(handleError);
  }

  postFileBankruptcy({
    userId,
    chapter,
    filedDate,
    reversed = false
  }) {
    const {
      POST_DECLARE_BANKRUPTCY
    } = ApiUrlConstants;

    return apiClient
      .post(
        POST_DECLARE_BANKRUPTCY, {
          userId,
          chapter,
          filedDate,
          reversed,
          unblockUser: false
        }).then(handleResponse).catch(handleError);
  }
  
  getFurnishingBloomAccount({
    productId
  }) {
    const {
      GET_FURNISHING_BLOOM_ACCOUNT
    } = ApiUrlConstants;

    const url = GET_FURNISHING_BLOOM_ACCOUNT
      .replace(/{productId}/g, productId);

    return apiClient.get(url).then(handleResponse).catch(handleError);
  }

  postFurnishingBloomAccountEvent({
    accountId,
    eventType,
    reversed = false,
    effectiveDate = null,
    amount = null,
    consumerRequested = false
  }) {
    const {
      POST_FURNISHING_BLOOM_ACCOUNT_EVENT
    } = ApiUrlConstants;

    const url = POST_FURNISHING_BLOOM_ACCOUNT_EVENT
      .replace(/{accountId}/g, accountId);

    return apiClient.post(url, {
      eventType,
      reversed,
      effectiveDate,
      amount,
      consumerRequested
    }).then(handleResponse).catch(handleError);
  }

  postWithdrawBankruptcy({
    userId,
    chapter,
    filedDate,
    reversed = false,
    unblockUser = false
  }) {
    const {
      POST_DECLARE_BANKRUPTCY
    } = ApiUrlConstants;

    return apiClient
      .post(
        POST_DECLARE_BANKRUPTCY, {
          userId,
          chapter,
          type: 'BANKRUPTCY_WITHDRAWN',
          filedDate,
          reversed,
          unblockUser
        }).then(handleResponse).catch(handleError);
  }

  postDischargeBankruptcy({
    userId,
    chapter,
    filedDate,
    reversed = false,
    unblockUser = false
  }) {
    const {
      POST_DECLARE_BANKRUPTCY
    } = ApiUrlConstants;

    return apiClient
      .post(
        POST_DECLARE_BANKRUPTCY, {
          userId,
          chapter,
          type: 'BANKRUPTCY_DISCHARGED',
          filedDate,
          reversed,
          unblockUser
        }).then(handleResponse).catch(handleError);
  }

  getAutoPayStatus({
    userId
  }) {
    const {
      GET_AUTO_PAY_STATUS
    } = ApiUrlConstants;
    
    const url = GET_AUTO_PAY_STATUS
      .replace(/{userId}/g, userId);

    return apiClient
      .get(
        url, {
          userId,
        }).then(handleResponse).catch(handleError);
  }

  setAutoPayStatus({
    userId,
    type,
    isDisabled,
    autoPayDay
  }) {
    const {
      POST_SET_AUTO_PAY_STATUS
    } = ApiUrlConstants;
    
    const url = POST_SET_AUTO_PAY_STATUS
      .replace(/{userId}/g, userId)
      .replace(/{type}/g, type);

    return apiClient
      .post(
        url, {
          isDisabled,
          autoPayDay
        }).then(handleResponse).catch(handleError);
  }

  getStatementFile({
    type,
    statementId
  }) {
    const {
      GET_STATEMENTS_BY_USER
    } = ApiUrlConstants;

    const url = GET_STATEMENTS_BY_USER
      .replace(/{type}/g, type)
      .replace(/{userId}/g, statementId);

    return apiClient.get(url, {responseType: 'arraybuffer'}).then(handleResponse).catch(handleError);
  }

  getProductStatementFile({
    type,
    statementId
  }) {
    const {
      GET_PRODUCT_STATEMENTS_BY_USER
    } = ApiUrlConstants;

    const url = GET_PRODUCT_STATEMENTS_BY_USER
      .replace(/{type}/g, type)
      .replace(/{statementId}/g, statementId);

    return apiClient.get(url, {responseType: 'arraybuffer'}).then(handleResponse).catch(handleError);
  }

   getReportFile({userId, reportId}) {
     const {
       GET_REPORT_BY_USER_ID_REPORT_ID
     } = ApiUrlConstants;

     const url = GET_REPORT_BY_USER_ID_REPORT_ID
         .replace(/{userId}/g, userId)
         .replace(/{reportId}/g, reportId);

     return apiClient
         .get(url, {
           responseType: 'text',
           transformResponse: [
             // Return the raw string instead of letting Axios parse it
             function (data) {
               return data;
             },
           ],
         })
         .then(handleResponse)
         .catch(handleError);
  }

  getCreditCardStatements({
    accountId
  }) {
    const {
      GET_STATEMENTS_BY_ACCOUNT_ID
    } = ApiUrlConstants;

    const url = GET_STATEMENTS_BY_ACCOUNT_ID
      .replace(/{accountId}/g, accountId);

    return apiClient.get(url).then(handleResponse).catch(handleError);
  }

  getPaymentAttempts(userId) {
    const {
      GET_PAYMENT_ATTEMPTS
    } = ApiUrlConstants;
    const url = GET_PAYMENT_ATTEMPTS.replace(/{userId}/g, userId);

    return apiClient.get(url).then(handleResponse).catch(handleError);
  }
  

  getCreditCardsLegacy({
    userId
  }) {
    const {
      GET_CC_LEGACY_ACCOUNTS_BY_USER_ID
    } = ApiUrlConstants;

    const url = GET_CC_LEGACY_ACCOUNTS_BY_USER_ID
      .replace(/{userId}/g, userId);

    return apiClient.get(url).then(handleResponse).catch(handleError);
  }

  getCreditCards({
    userId
  }) {
    const {
      GET_CC_ACCOUNTS_BY_USER_ID
    } = ApiUrlConstants;

    const url = GET_CC_ACCOUNTS_BY_USER_ID
      .replace(/{userId}/g, userId);

    return apiClient.get(url).then(handleResponse).catch(handleError);
  }
  
  getCreditCardsActivity({
    accountId
  }) {
    const {
      GET_CC_ACCOUNT_ACTIVITY_BY_ACCOUNT_ID
    } = ApiUrlConstants;

    const url = GET_CC_ACCOUNT_ACTIVITY_BY_ACCOUNT_ID
      .replace(/{accountId}/g, accountId);

    return apiClient.get(url).then(handleResponse).catch(handleError);
  }
  
  revealUserSSN({
    userId
  }) {
    const {
      GET_REVEAL_USER_SSN
    } = ApiUrlConstants;

    const url = GET_REVEAL_USER_SSN
      .replace(/{userId}/g, userId);

    return apiClient.get(url).then(handleResponse).catch(handleError);
  }
  
  matchUserSSN({
    userId,
    ssn
  }) {
    const {
      POST_MATCH_USER_SSN
    } = ApiUrlConstants;

    const url = POST_MATCH_USER_SSN
      .replace(/{userId}/g, userId);

    return apiClient.post(url, { ssn }).then(handleResponse).catch(handleError);
  }
  
  getTOS({
    userId
  }) {
    const {
      GET_USER_TOS
    } = ApiUrlConstants;

    const url = GET_USER_TOS
      .replace(/{userId}/g, userId);

    return apiClient.get(url).then(handleResponse).catch(handleError);
  }
  
  getSubscriptionWinback({
    userId,
    annualUpgrade = null
  }) {
    const {
      GET_SUBSCRIPTION_CANCELLATION_OFFER
    } = ApiUrlConstants;

    const url = GET_SUBSCRIPTION_CANCELLATION_OFFER
      .replace(/{userId}/g, userId) + (annualUpgrade === null ? '' : annualUpgrade ? '?annualUpgrade=true' : '?annualUpgrade=false');

    return apiClient.get(url).then(handleResponse).catch(handleError);
  }

  getUserBalance({
    userId,
    accountId
  }) {
    const {
      GET_USER_BALANCE
    } = ApiUrlConstants;

    const url = GET_USER_BALANCE
      .replace(/{userId}/g, userId);

    return apiClient.post(url, { accountId }).then(handleResponse).catch(handleError);
  }

  getLoanDetails({
    userId
  }) {
    const {
      GET_LOAN_DETAILS
    } = ApiUrlConstants;

    const url = GET_LOAN_DETAILS
      .replace(/{userId}/g, userId);

    return apiClient.get(url).then(handleResponse).catch(handleError);
  }

  getLoanStatements({
    loanId
  }) {
    const {
      GET_LOAN_STATEMENTS
    } = ApiUrlConstants;

    const url = GET_LOAN_STATEMENTS
      .replace(/{loanId}/g, loanId);

    return apiClient.get(url).then(handleResponse).catch(handleError);
  }

  revokeLogin({
    userId
  }) {
    const {
      GET_REVOKE_LOGIN
    } = ApiUrlConstants;

    const url = GET_REVOKE_LOGIN
      .replace(/{userId}/g, userId);

    return apiClient.get(url).then(handleResponse).catch(handleError);
  }

  riskCheck(userId, flow) {
    const {RISK_CHECK} = ApiUrlConstants;
    return apiClient.post(RISK_CHECK, {
      userId: userId,
      flow: flow
    })
    .then(handleResponse).catch(handleError);
  }

  getDocumentVerificationResult({ userId, id }) {
    const url = ApiUrlConstants.GET_DOCUMENT_VERIFICATION_RESULT
      .replace(/{userId}/g, userId)
      .replace(/{id}/g, id);
    return apiClient.get(url).then(handleResponse).catch(handleError);
  }

  getDocumentVerificationImages({ userId, id }) {
    const url = ApiUrlConstants.GET_DOCUMENT_VERIFICATION_IMAGES
      .replace(/{userId}/g, userId)
      .replace(/{id}/g, id);
    return apiClient.get(url).then(handleResponse).catch(handleError);
  }

  spendMode(userId, spendMode, creditAccountId) {
    const { SPEND_MODE } = ApiUrlConstants;
    return apiClient.post(SPEND_MODE, {
      userId,
      spendMode,
      creditAccountId
    }).then(handleResponse).catch(handleError);
  }

  resetMerchantCycle(userId, creditCardAccountId) {
    const { RESET_MERCHANT_CYCLE } = ApiUrlConstants;
    return apiClient.post(RESET_MERCHANT_CYCLE, {
      userId,
      creditCardAccountId
    }).then(handleResponse).catch(handleError);
  }
  
  avaAssist(userId) {
    const {AVA_ASSIST} = ApiUrlConstants;
    return apiClient.get(AVA_ASSIST.replace(/{userId}/, userId))
      .then(handleResponse).catch(handleError);
  }

  bloomConnections(userId) {
    const {BLOOM_CONNECTIONS} = ApiUrlConstants;
    return apiClient.get(BLOOM_CONNECTIONS, {params: {userId}})
      .then(handleResponse).catch(handleError);
  }

  tradelines(userId, includeAll) {
    const {TRADELINES} = ApiUrlConstants;
    return apiClient.get(TRADELINES, {params: {userId, includeAll}})
      .then(handleResponse).catch(handleError);
  }

  setStripePrimaryCard(userId, cardId) {
    const {SET_STRIPE_PRIMARY_CARD} = ApiUrlConstants;

    return apiClient.post(
      SET_STRIPE_PRIMARY_CARD, 
      {userId, cardId}
    ).then(handleResponse).catch(handleError);
  }

  getHighRiskRules(userId) {
    const {GET_HIGH_RISK_RULES} = ApiUrlConstants;
    const url = GET_HIGH_RISK_RULES.replace(/{userId}/g, userId);

    return apiClient.get(url).then(handleResponse).catch(handleError);
  }

  allowlistRule(userId, ruleId, ruleName, expirationTs, comment) {
    const {ALLOWLIST_RULE} = ApiUrlConstants;
    
    return apiClient.post(ALLOWLIST_RULE, {
      userId,
      ruleId,
      ruleName,
      expirationTs,
      comment
    }).then(handleResponse).catch(handleError);
  }

  getAllowlistedRules(userId) {
    const {GET_ALLOWLISTED_RULES} = ApiUrlConstants;
    return apiClient.get(GET_ALLOWLISTED_RULES.replace(/{userId}/, userId))
      .then(handleResponse).catch(handleError);
  }

  getSavingsBuilder(userId) {
    const {GET_SAVINGS_BUILDER} = ApiUrlConstants;
    const url = GET_SAVINGS_BUILDER.replace(/{userId}/g, userId);

    return apiClient.get(url).then(handleResponse).catch(handleError);
  }

  getMoneyTransactions(userId) {
    const {GET_MONEY_TRANSACTIONS} = ApiUrlConstants;
    const url = GET_MONEY_TRANSACTIONS.replace(/{userId}/g, userId);

    return apiClient.get(url).then(handleResponse).catch(handleError);
  }

  getSubscriptionPaymentIssues(userId) {
    const {GET_SUBSCRIPTION_PAYMENT_ISSUES} = ApiUrlConstants;
    const url = GET_SUBSCRIPTION_PAYMENT_ISSUES.replace(/{userId}/g, userId);
    return apiClient.get(url).then(handleResponse).catch(handleError);
  }
  
  getIterableEmails(userId) {
    const {GET_ITERABLE_EMAILS} = ApiUrlConstants;
    const url = GET_ITERABLE_EMAILS.replace(/{userId}/g, userId);
    return apiClient.get(url).then(handleResponse).catch(handleError);
  }

  getMerchantActivationV3Experience({ userId }) {
    const {GET_MERCHANT_ACTIVATION_V3_EXPERIENCE} = ApiUrlConstants;
    const url = GET_MERCHANT_ACTIVATION_V3_EXPERIENCE.replace(/{userId}/g, userId);

    return apiClient.get(url).then(handleResponse).catch(handleError);
  }

  getMerchantActivationMerchantToAddList({ userId }) {
    const {GET_MERCHANT_ACTIVATION_MERCHANT_TO_ADD_LIST} = ApiUrlConstants;
    const url = GET_MERCHANT_ACTIVATION_MERCHANT_TO_ADD_LIST.replace(/{userId}/g, userId);

    return apiClient.get(url).then(handleResponse).catch(handleError);
  }

  getMerchantActivationMerchantsList({ userId }) {
    const {GET_MERCHANT_ACTIVATION_MERCHANTS_LIST} = ApiUrlConstants;
    const url = GET_MERCHANT_ACTIVATION_MERCHANTS_LIST.replace(/{userId}/g, userId);

    return apiClient.get(url).then(handleResponse).catch(handleError);
  }

  postMerchantActivationAddNewMerchant({ userId, merchantName, allocatedSpendLimit }) {
    const {POST_MERCHANT_ACTIVATION_ADD_NEW_MERCHANT} = ApiUrlConstants;
    const url = POST_MERCHANT_ACTIVATION_ADD_NEW_MERCHANT.replace(/{userId}/g, userId);

    const body = { merchantName, allocatedSpendLimit };

    return apiClient.post(url, body).then(handleResponse).catch(handleError);
  }

  refundNegativeBalance({ userId, creditCardAccountId, refundAmountCents }) {
    const { REFUND_NEGATIVE_BALANCE } = ApiUrlConstants;
    return apiClient.post(REFUND_NEGATIVE_BALANCE, {
      userId,
      creditCardAccountId,
      refundAmountCents
    }).then(handleResponse).catch(handleError);
  }

  deleteMerchantActivationMerchant({ userId, merchantName }) {
    const {DELETE_MERCHANT_ACTIVATION_MERCHANT} = ApiUrlConstants;
    const url = DELETE_MERCHANT_ACTIVATION_MERCHANT.replace(/{userId}/g, userId).replace(/{merchantName}/g, merchantName);

    return apiClient.delete(url).then(handleResponse).catch(handleError);
  }

  deleteMerchantActivationMerchantByAva({ userId, merchantName }) {
    const {DELETE_MERCHANT_ACTIVATION_MERCHANT_BY_AVA} = ApiUrlConstants;
    const url = DELETE_MERCHANT_ACTIVATION_MERCHANT_BY_AVA.replace(/{userId}/g, userId).replace(/{merchantName}/g, merchantName);

    return apiClient.delete(url).then(handleResponse).catch(handleError);
  }

  getMoneyMovements({ userId, planExecutionId }) {
    const { GET_MONEY_MOVEMENTS } = ApiUrlConstants;
    return apiClient.get(GET_MONEY_MOVEMENTS, {
      params: { userId, planExecutionId }
    }).then(handleResponse).catch(handleError);
  }
}

export default new API();